import { css } from '@emotion/core';


/**
 * Apply to the form root for all of its immediate children to space themselves out vertically by 12px
 */
export const FORM_COLUMN = css`
  & > span {
    display: block;
  }
  & > * {
    margin-bottom: 12px;
  }
  & > *:last-child {
    margin-bottom: 0;
  }
`;

/**
 * ... or horizontally by 12px
 */
export const FORM_ROW = css`
  & > * {
    margin-right: 12px;
  }
  & > *:last-child {
    margin-right: 0;
  }
`;
